import { ListStepTemplatesResponseSchema } from './list-step-templates.schema';
/**
 * List Step Templates Endpoint Contract
 * Retrieves all step templates of the tenant, newest first
 */ export const listStepTemplatesContract = {
    method: 'GET',
    path: '/api/v2/step-template',
    description: 'Retrieve all step templates of the tenant',
    responseSchema: ListStepTemplatesResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden'
        }
    }
};

//# sourceMappingURL=list-step-templates.contract.js.map